import FilterLabel from './FilterLabel';
export { FilterLabel };
export default FilterLabel;
